import { Button, Upload, UploadFile, UploadProps } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { uploadAppointments } from "../../../services/dataService";
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { getSharedState } from "../../../store/selectors/stateSelector";
import { apiConfig } from './../../../configs/api';
import { apiService } from "../../../services/apiService";
import { setEvent } from "../../../store/reducers/sharedReducer";
import { ApiActions, ApiEventType } from "../../../models/event";

export const BulkUploadAppointments = (props: any) => {

    const dispatch = useDispatch();
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const { loading } = useSelector(getSharedState);

    const downloadTemplate = async () => {
        // Open the window before awaiting, otherwise the browser blocks it as a popup.
        const templateWindow = window.open('', '_blank');
        try {
            // The template is in a private container, so it needs a read signature.
            const containerName = new URL(apiConfig.bulkUploadFileTemplateUrl).pathname.split('/')[1];
            const signature = await apiService.generateReadSignature(containerName);
            const url = `${apiConfig.bulkUploadFileTemplateUrl}${signature}`;
            if (templateWindow) {
                templateWindow.location.href = url;
            } else {
                window.open(url);
            }
        } catch (e) {
            templateWindow?.close();
            dispatch(setEvent({
                type: ApiEventType.Error,
                action: ApiActions.OnError,
                message: "An error occurred while downloading the template"
            }));
        }
    };

    const uploadProps: UploadProps = {
      accept: ".xlsx",
      onRemove: (file) => {
        setFileList([]);
      },
      beforeUpload: (file) => {
        setFileList([file]);
        return false;
      },
      fileList,
    };
  
    const handleUpload = () => {
        dispatch<any>(uploadAppointments(fileList[0]));
        setFileList([]);
    };

    return (
        <>
            <Button icon={<DownloadOutlined />} onClick={downloadTemplate}>
                Template
            </Button>
            <Upload {...uploadProps}>
                  <Button icon={<UploadOutlined />}>Select File</Button>
                </Upload>
            <Button
                type="primary"
                onClick={handleUpload}
                disabled={fileList.length === 0}
                loading={loading}
            >
                Start Upload
            </Button>
        </>
    )
};
